export function distance(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
}
export function pointToSegmentDistance(px, py, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const lenSq = dx * dx + dy * dy;
    if (lenSq === 0)
        return distance(px, py, x1, y1);
    let t = ((px - x1) * dx + (py - y1) * dy) / lenSq;
    t = Math.max(0, Math.min(1, t));
    const projX = x1 + t * dx;
    const projY = y1 + t * dy;
    return distance(px, py, projX, projY);
}
export function boundingBox(points) {
    if (points.length === 0)
        return { x: 0, y: 0, width: 0, height: 0 };
    let minX = points[0].x;
    let minY = points[0].y;
    let maxX = points[0].x;
    let maxY = points[0].y;
    for (let i = 1; i < points.length; i++) {
        const p = points[i];
        if (p.x < minX)
            minX = p.x;
        if (p.y < minY)
            minY = p.y;
        if (p.x > maxX)
            maxX = p.x;
        if (p.y > maxY)
            maxY = p.y;
    }
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}
export function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
export function normalizeRect(x1, y1, x2, y2) {
    const x = Math.min(x1, x2);
    const y = Math.min(y1, y2);
    const width = Math.abs(x2 - x1);
    const height = Math.abs(y2 - y1);
    return { x, y, width, height };
}
/**
 * Computes an SVG matrix() transform string that rotates around (cx, cy)
 * in screen space, compensating for the non-uniform viewBox scaling.
 *
 * The viewBox is "0 0 1 1" with preserveAspectRatio="none", so x and y
 * scale differently. A naive rotate() would appear skewed.
 */
export function computeRotationTransform(angleDeg, cx, cy, containerWidth, containerHeight) {
    const rad = (angleDeg * Math.PI) / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    const W = containerWidth;
    const H = containerHeight;
    const a = cos;
    const b = sin * (W / H);
    const c = -sin * (H / W);
    const d = cos;
    const e = cx * (1 - cos) + cy * sin * (H / W);
    const f = cy * (1 - cos) - cx * sin * (W / H);
    return `matrix(${a}, ${b}, ${c}, ${d}, ${e}, ${f})`;
}
/**
 * Rotates a point around a center in screen space, returning the result
 * in normalized SVG coordinates.  Useful for computing the true rotated
 * position of handles/dots when the viewBox has non-uniform scaling.
 */
export function rotatePointScreenSpace(px, py, cx, cy, angleDeg, containerWidth, containerHeight) {
    if (angleDeg === 0)
        return { x: px, y: py };
    const rad = (angleDeg * Math.PI) / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    // Delta in screen pixels
    const dx = (px - cx) * containerWidth;
    const dy = (py - cy) * containerHeight;
    // Rotate in screen space, convert back to normalized coords
    return {
        x: cx + (dx * cos - dy * sin) / containerWidth,
        y: cy + (dx * sin + dy * cos) / containerHeight,
    };
}
